import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Bold = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M7 5H13.1442C13.7347 5 14.2634 5.08691 14.7303 5.26074C15.211 5.43457 15.6161 5.67526 15.9457 5.98281C16.2753 6.29035 16.5225 6.67144 16.6873 7.12607C16.8658 7.56734 16.9551 8.0554 16.9551 8.59026C16.9551 9.12512 16.8795 9.57975 16.7285 9.95415C16.5911 10.3152 16.3989 10.616 16.1517 10.8567C15.9182 11.0974 15.6436 11.2779 15.3277 11.3983C15.0256 11.5186 14.7097 11.5855 14.3801 11.5989V11.7192C14.696 11.7192 15.0325 11.7794 15.3895 11.8997C15.7603 12.0201 16.0968 12.2139 16.3989 12.4814C16.7147 12.7354 16.9757 13.0697 17.1816 13.4842C17.3876 13.8854 17.4906 14.3868 17.4906 14.9885C17.4906 15.5501 17.3945 16.0783 17.2022 16.5731C17.0237 17.0544 16.7697 17.4756 16.4401 17.8367C16.1105 18.1977 15.7191 18.4852 15.2659 18.6991C14.8127 18.8997 14.3184 19 13.7828 19H7V5ZM9.7191 16.7536H13C13.5218 16.7536 13.927 16.6266 14.2154 16.3725C14.5037 16.1051 14.6479 15.724 14.6479 15.2292V14.5473C14.6479 14.0525 14.5037 13.6714 14.2154 13.404C13.927 13.1366 13.5218 13.0029 13 13.0029H9.7191V16.7536ZM9.7191 10.8367H12.5674C13.0618 10.8367 13.4463 10.7096 13.721 10.4556C13.9956 10.1882 14.133 9.82044 14.133 9.35244V8.73066C14.133 8.26265 13.9956 7.90162 13.721 7.64756C13.4463 7.38013 13.0618 7.24642 12.5674 7.24642H9.7191V10.8367Z"
        fill={color}
      />
    </svg>
  )
})

export default Bold
